/**
 * Check if a value is a valid hex color
 * @param value
 * @returns
 */
export const isHexColor = (value: string): boolean => /^#([A-Fa-f0-9]{3,4}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(value);
